import { Component } from '@angular/core';
import { ColmecPartnerAgreementsListConfigService } from '../../services/colmec-partner-agreements-list-config.service';
import { ColmecModalService } from '../../services/colmec-modal.service';

@Component({
    selector: 'colmec-partner-agreements-list',
    templateUrl: './colmec-partner-agreements-list.component.html',
    styleUrls: ['./colmec-partner-agreements-list.component.scss'],
    standalone: false
})
export class ColmecPartnerAgreementsListComponent {
  constructor(
    protected configService: ColmecPartnerAgreementsListConfigService,
    protected colmecModalService: ColmecModalService
  ) {}

  public openCreateAgreementModal(): void {
    this.colmecModalService.openCreateEditPartnerAgreementModal().then(
      result => {},
      reject => {}
    );
  }
}
